import { render, staticRenderFns } from "./talkToDocWindow.vue?vue&type=template&id=54757882"
import script from "./talkToDocWindow.vue?vue&type=script&lang=js"
export * from "./talkToDocWindow.vue?vue&type=script&lang=js"
import style0 from "./talkToDocWindow.vue?vue&type=style&index=0&id=54757882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports